import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Video, PlayCircle, Building } from "lucide-react";

const trainingOptions = [
  {
    id: 1,
    icon: Video,
    title: "Online Live Sessions",
    description: "Live instructor-led training with real-time interaction and Q&A sessions",
    features: ["Interactive sessions", "Real-time doubt clearing", "Flexible scheduling"]
  },
  {
    id: 2,
    icon: PlayCircle,
    title: "Self-Paced Courses",
    description: "Recorded content with exercises you can complete at your own pace",
    features: ["Learn anytime", "Lifetime access", "Practice exercises"]
  },
  {
    id: 3,
    icon: Building,
    title: "Corporate Training",
    description: "Custom programs designed specifically for your team's needs",
    features: ["Tailored curriculum", "On-site or remote", "Team progress tracking"]
  }
];

const TrainingOptions = () => {
  return (
    <section 
      data-testid="training-options-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 
            data-testid="training-options-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A]"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Training Options
          </h2>
          <p className="mt-4 text-lg text-[#0F172A]/60 max-w-2xl mx-auto">
            Choose the learning format that works best for you
          </p>
        </div>

        {/* Options Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {trainingOptions.map((option) => (
            <div
              key={option.id}
              data-testid={`training-option-${option.id}`}
              className="bg-[#F8FAFC] border border-slate-200 rounded-2xl p-8 hover:border-[#2563EB]/30 hover:shadow-lg transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-[#2563EB] flex items-center justify-center mb-6">
                <option.icon className="w-7 h-7 text-white" />
              </div>

              <h3 
                className="text-xl font-bold text-[#0F172A] mb-3"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {option.title}
              </h3>
              <p className="text-[#0F172A]/60 mb-6 leading-relaxed">
                {option.description}
              </p>

              {/* Features */}
              <ul className="space-y-2">
                {option.features.map((feature, index) => (
                  <li 
                    key={index}
                    className="flex items-center gap-2 text-sm text-[#0F172A]/70"
                  >
                    <div className="w-1.5 h-1.5 rounded-full bg-[#06B6D4]"></div>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="text-center mt-12">
          <Link to="/contact">
            <Button 
              data-testid="training-options-cta"
              className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-8 py-6 text-base font-medium rounded-xl"
            >
              Get Started
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TrainingOptions;
